<template>
    <div class="content-div">
        <div class="form-box">
            <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="90px">
                <!--                <div class="top-title">基础信息</div>-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="上传DBC文件 : " label-width="120px" prop="file">
                            <el-upload
                                    class="upload-demo"
                                    action="##"
                                    :http-request="uploadDbcFile"
                                    :before-upload="beforeUpload"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    multiple
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <!--                            <el-input class="inputClass" :disabled="dialogType === 2" v-model="drawerForm.vin" placeholder="请输入" size="small"></el-input>-->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="120px" label="所属车型 : " prop="vehicleType">
                            <el-select class="inputClass" v-model="drawerForm.vehicleTypeName" placeholder="请选择" @change="changeSelect"
                                       size="small">
                                <el-option
                                        v-for="item in carOptions"
                                        :key="item.vehicleTypeCode"
                                        :label="item.vehicleTypeName"
                                        :value="item.vehicleTypeCode + '-' + item.vehicleTypeName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="120px" label="备注 : ">
                            <el-input
                                    class="inputClass"
                                    type="textarea"
                                    :rows="6"
                                    placeholder="请输入内容"
                                    v-model="drawerForm.remark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="bottom-btn">
            <el-button @click="submitData(1)" :loading="submitType" type="primary" size="mini">确定</el-button>
            <el-button @click="submitData(2)" size="mini">取消</el-button>
        </div>
    </div>
</template>

<script>
    import {addDataDbcFile,uploadDbcFile,updateDataDbcFile} from "../../../common/dbc";
    import {getDatavehicleTypeList} from "../../../common/carModelApi"

    export default {
        name: "dbcDialog",
        props: {
            drawerForm: {
                type: Object,
            },
            dialogType: {
                type: Number
            }
        },
        data() {
            const validateLogo = (rule, value, callback) => {
                if (!this.drawerForm.filePath) {
                    callback(new Error('请上传文件'))
                } else {
                    callback()
                }
            }
            return {
                fileList: [],
                rules: {
                    file: [{required: true, validator: validateLogo, trigger: 'change'}]
                },
                submitType: false,
                carOptions: []
            }
        },
        mounted() {
            this.getDatavehicleTypeList()
            if (this.drawerForm.fileName) {
                this.fileList = [
                    {
                        name:this.drawerForm.fileName,
                        url:this.drawerForm.filePath
                    }
                ]
            }

        },
        methods: {
            changeSelect(e) {
                this.drawerForm.vehicleType = e.split('-')[0];
                this.drawerForm.vehicleTypeName = e.split('-')[1];
                console.log(this.drawerForm)
            },
            uploadDbcFile(params) {
                const file = params.file;
                console.log(file.name)
                this.drawerForm.fileName = file.name
                // 根据后台需求数据格式
                const form = new FormData();
                // 文件对象
                form.append('file', file);
                // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
                form.append('clientType', 'xxx');
                uploadDbcFile(form).then(res=>{
                    this.drawerForm.filePath = res.data
                    this.fileList = [
                        {
                            name:this.drawerForm.fileName,
                            url:this.drawerForm.filePath
                        }
                    ]
                }).catch(err=>{
                    console.log(err)
                })
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                console.log(testmsg)
                const extension1 = testmsg === 'dbc'
                if (
                    !extension1
                ) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '上传文件只能是.dbc格式!'
                    })
                    return false
                }
                // else {
                //     return true
                // }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                console.log(files)
                var testmsg = files[0].name.substring(files[0].name.lastIndexOf('.') + 1)
                console.log(testmsg)
                const extension1 = testmsg === 'dbc'
                if (
                    !extension1
                ) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '上传文件只能是.dbc格式!'
                    })
                    return false
                }
                if (files.length === 1) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '当前限制选择 1 个文件!'
                    })
                    return false
                }
                // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                if (file && file.status==="success") {
                    return this.$confirm(`确定移除 ${file.name}？`);
                }

            },
            // async querySearch(queryString, cb) {
            //     const res = await getDataTboxListNoUse({imei: queryString})
            //     if (res.code === 200) {
            //         // // 调用 callback 返回建议列表的数据
            //         cb(res.data);
            //     } else {
            //         this.$notify.error({
            //             title: '错误提示',
            //             message: res.msg
            //         })
            //     }
            // },


            // 数据提交
            async submitData(type) {
                /*
                  * dialogType
                  * 1   新增
                  * 2   修改
                  * */
                if (type === 1) {
                    this.$refs.ruleForm.validate(async (valid) => {
                        if (valid) {
                            // let str = ''
                            // this.carOptions.find(item => {
                            //     if (item.vehicleTypeCode === this.drawerForm.vehicleType) {
                            //         str = item.vehicleTypeName
                            //     }
                            // })
                            // this.drawerForm.vehicleTypeName = str
                            this.submitType = true
                            if (this.dialogType === 1) {
                                try {
                                    const res = await addDataDbcFile(this.drawerForm)
                                    if (res.code === 200) {
                                        this.$notify.success({
                                            title: '成功提示',
                                            message: '新增成功'
                                        })
                                        this.submitType = false
                                        this.$emit('drawerClose')
                                    } else {
                                        this.$notify.error({
                                            title: '错误提示',
                                            message: res.msg
                                        })
                                        this.submitType = false
                                    }
                                } catch (e) {
                                    this.submitType = false
                                    console.log(e)
                                }
                            } else {
                                try {
                                    const res = await updateDataDbcFile(this.drawerForm)
                                    if (res.code === 200) {
                                        this.$notify.success({
                                            title: '成功提示',
                                            message: '修改成功'
                                        })
                                        this.submitType = false
                                        this.$emit('drawerClose')
                                    } else {
                                        this.$notify.error({
                                            title: '错误提示',
                                            message: res.msg
                                        })
                                        this.submitType = false
                                    }
                                } catch (e) {
                                    this.submitType = false
                                    console.log(e)
                                }
                            }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } else {
                    this.$emit('drawerClose')
                }
            },
            // 获取车型列表
            async getDatavehicleTypeList() {
                try {
                    const res = await getDatavehicleTypeList()
                    if (res.code === 200) {
                        this.carOptions = res.data
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: res.msg
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            },
        }
    }
</script>

<style scoped>
    .content-div /deep/ .el-form-item__error {
        padding-top: 0 !important;
    }

    .form-box {
        box-sizing: border-box;
        padding: 0 60px 0 20px;
    }

    .form-box /deep/ .el-form-item {
        margin-bottom: 10px !important;
    }

    .top-title {
        text-align: left;
        margin-bottom: 20px;
        margin-top: 20px;
        font-size: 18px;
        font-weight: 700;
    }

    .bottom-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    .inputClass {
        width: 320px;
    }
</style>
